<div class="panel panel-default">
    <div class="panel-body">
        <app-project-summary-table [rows]="rows" [selectedProjectIds]="selectedProjectIds"
            [indicateNewProjects]="indicateNewProjects" [newSince]="newSince" [updatedSince]="updatedSince"
            [usage]="usage" [sort]="sort" [actions]="actions" (rowSelected)="onProjectSelected($event)"
            (selectionChanged)="onSelectionChanged($event)" (restoreRequested)="onRestoreRequested($event)"
            (sortChanged)="onSortChanged($event)">
        </app-project-summary-table>
    </div>
</div>